module.exports = __webpack_public_path__ + "img/logo.f54298d1.png";